import { createAsyncThunk } from '@reduxjs/toolkit';
import { POPUP_CONNECTION_STATE, popupSteps } from "../../../../../store/common/constants";
import { getTargetTariffType } from "../selectors/orderTariffCommon";
import { getCurrentFormStep } from "../selectors/modal";
import { setNextStep, setStatusConnection } from "../reducers/slice";
import { setFlat } from "./common";
export var handleOrderStepsSecondProgress = createAsyncThunk('handleOrderStepsSecondProgress', function (_, _ref) {
  var dispatch = _ref.dispatch,
    getState = _ref.getState;
  var state = getState();
  var currentStep = getCurrentFormStep(state);
  var _getTargetTariffType = getTargetTariffType(state),
    tariffUrl = _getTargetTariffType.tariffUrl;
  if (currentStep === popupSteps.addressNotAvailableModal) {
    dispatch(setFlat(''));
    dispatch(setStatusConnection(POPUP_CONNECTION_STATE.isNone));
    return dispatch(setNextStep(popupSteps.addressRequestForm));
  }
  if (currentStep === popupSteps.addressRequestForm) {
    // метод ссылки для конструктора
    window.location.href = tariffUrl;
  }
  return null;
});